import { useState } from "react"
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react"

const compare = (a, b, order) => {
  if (b < a) return order === "desc" ? -1 : 1
  if (b > a) return order === "desc" ? 1 : -1
  return 0
}

const getValue = (row, columns, field) =>
  columns[field].render ? columns[field].render(row) : row[field]

const getComparator = (order, orderBy, columns) => (a, b) =>
  compare(getValue(a, columns, orderBy), getValue(b, columns, orderBy), order)

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

const DataTable = ({ columns, rows, onRowClick }) => {
  const [order, setOrder] = useState("asc")
  const [orderBy, setOrderBy] = useState(Object.keys(columns)[0])

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc"
    setOrder(isAsc ? "desc" : "asc")
    setOrderBy(property)
  }

  return (
    <Table variant="simple" size="md">
      <Thead>
        <Tr>
          {Object.entries(columns).map(
            ([field, { textAlign = "left", label, expand, sort = true }]) => (
              <Th
                key={field}
                textAlign={textAlign}
                color={orderBy === field ? "teal.600" : "gray.600"}
                cursor="pointer"
                onClick={() => sort && handleRequestSort(field)}
                userSelect="none"
                w={expand ? "full" : "auto"}
              >
                {label}
              </Th>
            )
          )}
        </Tr>
      </Thead>
      <Tbody>
        {stableSort(rows, getComparator(order, orderBy, columns)).map((row) => (
          <Tr
            key={row.id}
            cursor="pointer"
            onClick={() => onRowClick(row)}
            _hover={{ bg: "gray.100" }}
          >
            {Object.entries(columns).map(
              ([field, { textAlign = "left", render, expand }]) => (
                <Td
                  key={field}
                  textAlign={textAlign}
                  w={expand ? "full" : "auto"}
                  whiteSpace="nowrap"
                >
                  {render ? render(row) : row[field]}
                </Td>
              )
            )}
          </Tr>
        ))}
      </Tbody>
    </Table>
  )
}

export default DataTable
